import React, { useEffect, useState } from "react";
import { adminApi, getAdminToken } from "@/api/adminOneClient";

export default function AdminAudit() {
  const [rows, setRows] = useState([]);
  const [type, setType] = useState("");
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setBusy(true);
    try { const { data } = await adminApi.audit({ event_type: type || undefined, limit: 200 }); setRows(data?.events || []); }
    finally { setBusy(false); }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [type]);

  const downloadCsv = async () => {
    try {
      const url = adminApi.auditCsvUrl() + (type ? `?event_type=${encodeURIComponent(type)}` : "");
      const resp = await fetch(url, { headers: { Authorization: `Bearer ${getAdminToken()}` } });
      if (!resp.ok) return;
      const blob = await resp.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = "adminone_audit.csv";
      document.body.appendChild(a); a.click(); a.remove();
    } catch { /* ignore */ }
  };
  return (
    <div className="admin-page" data-testid="admin-audit">
      <div className="admin-page__head">
        <h2 className="admin-page__title">Audit Log</h2>
        <div className="admin-filters">
          <input type="text" placeholder="event_type filter (e.g., admin_login)" value={type} onChange={(e)=>setType(e.target.value)} onKeyDown={(e)=>e.key==="Enter" && load()} />
          <button className="oracle-btn oracle-btn--ghost oracle-btn--sm" onClick={load} disabled={busy}>{busy?"…":"Apply"}</button>
          <button
            type="button"
            className="oracle-btn oracle-btn--gold oracle-btn--sm"
            onClick={downloadCsv}
            data-testid="audit-export-csv"
          >⬇ Export CSV</button>
        </div>
      </div>
      <table className="admin-table">
        <thead><tr><th>Time</th><th>Event</th><th>Actor</th><th>Role</th><th>IP</th><th>Metadata</th></tr></thead>
        <tbody>
          {rows.map((r,i)=>(
            <tr key={r.id || i}>
              <td>{r.created_at && new Date(r.created_at).toLocaleString()}</td>
              <td><b>{r.event_type}</b></td>
              <td>{r.actor || "—"}</td>
              <td>{r.role || "—"}</td>
              <td>{r.ip || "—"}</td>
              <td className="admin-table__truncate">{r.metadata ? JSON.stringify(r.metadata).slice(0,160) : "—"}</td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={6} className="oracle-empty" style={{padding:14}}>No audit events.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
